import React from "react";
import { z } from "zod";
import { CommonSchemas } from "@a2ui/web_core/v0_9";
import { createComponentImplementation } from "@a2ui/react/v0_9";

// A single number, optionally with a small up/down trend indicator.
// Kept intentionally tiny: the backend's "one KPI" answers (e.g. "how many
// devices are online right now?") map straight onto this without needing
// the full basic-catalog Card/Text/Row composition every time.

const TrendSchema = z.object({
  // "up" | "down" | "flat" - free-form string, rendered defensively below.
  direction: CommonSchemas.DynamicString,
  // Pre-formatted by the backend, e.g. "+12%" or "-3 devices".
  magnitude: CommonSchemas.DynamicString.optional(),
});

export const MetricCardApi = {
  name: "MetricCard",
  schema: z.object({
    label: CommonSchemas.DynamicString,
    // Pre-formatted value string (e.g. "1,204", "98.6%") - formatting stays
    // on the backend so the frontend never guesses locale/precision rules.
    value: CommonSchemas.DynamicString,
    unit: CommonSchemas.DynamicString.optional(),
    trend: TrendSchema.optional(),
  }),
};

const TREND_GLYPH = { up: "▲", down: "▼", flat: "→" };
const TREND_CLASS = { up: "text-success", down: "text-danger", flat: "text-muted" };

export const MetricCard = createComponentImplementation(MetricCardApi, ({ props }) => {
  const direction = props.trend?.direction;
  return (
    <div className="card analytics-metric-card h-100">
      <div className="card-body">
        <div className="text-muted text-uppercase small mb-1">{props.label}</div>
        <div className="d-flex align-items-baseline gap-2">
          <span className="fs-3 fw-semibold">{props.value}</span>
          {props.unit && <span className="text-muted">{props.unit}</span>}
        </div>
        {props.trend && (
          <div className={`small mt-1 ${TREND_CLASS[direction] || "text-muted"}`}>
            <span>{TREND_GLYPH[direction] || ""}</span>{" "}
            <span>{props.trend.magnitude}</span>
          </div>
        )}
      </div>
    </div>
  );
});

export default MetricCard;
